import { render, staticRenderFns } from "./AddToWallet.vue?vue&type=template&id=23fe70b6"
import script from "./AddToWallet.vue?vue&type=script&lang=js"
export * from "./AddToWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports